<template>
	<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%; width: 100%;">
		<!--input类型示例-->
		<FormItem :label="$tt('充电站:')" :label-width="70" prop="StationId">
			<Select filterable :placeholder="$tt('站点列表')" style="width: 150px;" v-model="formInline.StationId">
				<Option :value=0>{{$tt('全部')}}</Option>
				<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">{{item.StationName}}</Option>
			</Select>
		</FormItem>
		<!-- <FormItem :label-width="90" :label="$tt('设备类型:')" prop="EquipmentType">
			<Select :placeholder="$tt('输入设备类型')" style="width:150px;" v-model="formInline.EquipmentType">
				<Option :value='1'>{{$tt('直流设备')}}</Option>
				<Option :value='2'>{{$tt('交流设备')}}</Option>
				<Option :value='3'>{{$tt('交直流一体设备')}}</Option>
				<Option :value='4'>{{$tt('无线设备')}}</Option>
				<Option :value='5'>{{$tt('其他')}}</Option>
			</Select>
		</FormItem> -->
		<!-- <FormItem prop="EquipmentModel">
			<Input style="width: 180px;" type="text" v-model="formInline.EquipmentModel" :placeholder="$tt('设备型号')">
				<span slot="prepend">{{$tt('设备型号')}}</span>
			</Input>
		</FormItem> -->
		<FormItem :label="$tt('设备型号')" :label-width="70" prop="EquipmentModel">
			<Select
				v-model="formInline.EquipmentModel"
				filterable
				:placeholder="$tt('请选择设备型号')"
				style="width:100%"
			>
				<Option key="0" :label="$tt('全部')" value=""></Option>
				<Option
					v-for="item in EquipmentModelDefine"
					:key="item.ModelId"
					:label="item.ModelDesc"
					:value="item.ModelId"
				/>
			</Select>
		</FormItem>
		
		<FormItem prop="EquipmentNo">
			<Input style="width: 200px;" type="text" v-model="formInline.EquipmentNo" :placeholder="$tt('设备编号')">
				<span slot="prepend">{{$tt('设备编号')}}</span>
			</Input>
		</FormItem>
		<FormItem prop="EquipmentSerialNo">
			<Input style="width: 200px;" type="text" v-model="formInline.EquipmentSerialNo" :placeholder="$tt('设备序列号')">
				<span slot="prepend">{{$tt('设备序列号:')}}</span>
			</Input>
		</FormItem>
		<FormItem>
			<Button type="primary" @click="$emit('handleSubmitList')">{{$tt('查询')}}</Button>
		</FormItem>
		<FormItem>
			<Button type="error" @click="$emit('Upgrade')">{{$tt('升级')}}</Button>
		</FormItem>
	</Form>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	export default {
		//props: ['param', 'url'],
		data() {
			return {
				formInline: {
					StationId: 0,
					EquipmentNo: '',
					EquipmentModel: '',
					EquipmentTypeDesc: '',
					EquipmentSerialNo: '',
				},
				PriceList: [{
					Id: 0,
					Name: 'name'
				}]
			};
		},
		computed: {
			...mapState({
				StationList: 'Stations',
				EquipmentModelDefine: 'EquipmentModelDefine'
			})
		},
		methods: {},
	}
</script>

<style>
</style>